
<template>
    <a @mousedown="mousedown" :class="getCss()"><slot/></a>
</template>

<style lang="scss">
    .inverted {
        filter: invert(100%);
        mix-blend-mode: difference;
    }
</style>

<script lang="ts">

import Events from "@/shared/support/Events";
import { defineComponent } from "vue";

export default defineComponent({
    name: "AButton",
    props: {
        class: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            inverted: false,
            flash: import.meta.env.VITE_FLASHBUTTON === "1"
        };
    },
    methods: {
        mousedown(ev: MouseEvent): void {
            if (!this.flash) return;
            this.inverted = true;
            this.$forceUpdate();
            Events.bubbleEvent(this, "mousedown", ev);
            setTimeout((): void => {
                this.inverted = false;
            }, 1000);
        },
        getCss(): string {
            return `${this.class}${this.inverted ? " inverted" : ""}`;
        }
    }
});

</script>
